import request from '@/utils/request';

import axios from 'axios';
import { getToken } from '@/utils/auth';
import store from '@/store';

const baseURLAdmin = process.env.VUE_APP_ADMIN;
const serviceNew = axios.create({
  baseURL: process.env.VUE_APP_TRACK_QUERY,
  timeout: 30000
  // headers: {
  //   'X-Token': getToken()
  // }
});
// 请求拦截器
serviceNew.interceptors.request.use(
  (config) => {
    // 在发送请求之前做一些事情
    if (store.getters.token) {
      // 让每个请求都带有令牌
      // ['X-Token'] is a custom headers key
      // 请根据实际情况进行修改
      config.headers['X-Token'] = getToken();
    }
    return config;
  },
  (error) => {
    // 做一些请求错误
    return Promise.reject(error);
  }
);
// 轨迹查询
export const getTrackQueryData = (orderNum) => {
  return serviceNew.get('/open/track?trackNo=' + orderNum);
  // return request({
  //   baseURL: process.env.VUE_APP_TRACK_QUERY,
  //   url: '/track?trackNo=' + orderNum
  // });
};
// 轨迹表 => 轨迹查询
export const getTrackQueryTable = (orderNum) => {
  return request({
    url: '/track/' + orderNum,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 轨迹聚合详情查询（包含发件/收件/包裹状态及轨迹列表）
export const getTrackQueryDetail = (orderNum) => {
  return request({
    url: '/track/detail/' + orderNum,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 手动更新轨迹
export const updateTrack = (orderNum) => {
  return serviceNew.post('/operation/register/order/number', orderNum);
};
const createUrl = process.env.VUE_APP_TAKENO;
// const createUrl = '/takeTrackNum';
export const logisticsOrder = (data) => {
  return request({
    method: 'POST',
    baseURL: createUrl,
    url: '/order/client/create',
    data: data
  });
};

// 取号
export const getTakeTrackNum = (data) => {
  return request({
    baseURL: createUrl,
    method: 'POST',
    url: '/exChange/api/create',
    data
  });
};

export const batchCreateOrder = (data) => {
  return request({
    method: 'POST',
    baseURL: createUrl,
    url: '/batch/client/create',
    data: data
  });
};

/**
 * @description 轨迹推送管理查询
 * @param data
 * @returns {AxiosPromise}
 */
export const trackPushLogPage = (data) => {
  return request({
    method: 'POST',
    url: '/trackPushLog/page',
    data: data
  });
};

/**
 * @description 轨迹接收管理查询
 * @param data
 * @returns {AxiosPromise}
 */
export const trackAcceptRecordPage = (data) => {
  return request({
    method: 'POST',
    url: '/trackAcceptRecord/page',
    data: data,
    baseURL: baseURLAdmin
  });
};
// 轨迹查询   调用跨境小包轨迹api
export const getproviderTrackQuery = (orderNum) => {
  return request({
    url: '/provider/order/track/query',
    method: 'post',
    data: orderNum,
    baseURL: baseURLAdmin
  });
};

// 快递轨迹查询
export const getTrackByWaybillNumbers = (data) => {
  return request({
    url: '/track/queryByWaybillNumbers',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

// 服务商轨迹匹配————分页
export const providerMatchExpressPage = (data) => {
  return request({
    method: 'POST',
    url: '/providerMatchExpress/page',
    data: data,
    baseURL: baseURLAdmin
  });
};

// 服务商轨迹匹配————批量轨迹匹配
export const savaBatchNormal = (data) => {
  return request({
    method: 'POST',
    url: '/providerMatchExpress/savaBatchNormal',
    data: data,
    baseURL: baseURLAdmin
  });
};

// 服务商轨迹匹配————批量修改匹配
export const updateBatchNormal = (data) => {
  return request({
    method: 'POST',
    url: '/providerMatchExpress/updateBatchNormal',
    data: data,
    baseURL: baseURLAdmin
  });
};

// 服务商轨迹匹配————轨迹匹配导入
export const importData = (data) => {
  return request({
    method: 'POST',
    url: '/providerMatchExpress/importData',
    data,
    baseURL: baseURLAdmin,
    headers: {
      'content-type': 'multipart/form-data; boundary=something'
    }
  });
};

/**
 * 查询启动的渠道
 */
export const getStartupProviderChannel = (data) => {
  return request({
    method: 'POST',
    url: '/provider/getProviderChannel',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 问题件类型
 */
export const getAllProblemType = (data) => {
  return request({
    url: '/collectProblem/getAllProblemType?problemItemType=' + data,
    method: 'get',
    isLoading: false,
    baseURL: baseURLAdmin
  });
};
